import { useMemo as o } from "react";
import { useStartChat as r } from "./contact-channels59.js";
const c = () => {
  const t = r();
  return o(() => ({
    startChatAction: { ...t }
  }), [t]);
};
export {
  c as useChatActions
};
//# sourceMappingURL=contact-channels10.js.map
